export default __webpack_public_path__ + "static/media/newblp_Users_sel.7e11308f.svg";